export { default as Dashboard } from './Dashboard';



// WEBPACK FOOTER //
// ./src/modules/Dashboard/pages/index.ts